import styled from "styled-components";

export const ModalOverlay = styled.div`
  background-color: rgba(25, 25, 25, 0.75) !important;

  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  width: 100vw;
  height: 100vh;

  position: fixed;
  z-index: 1000;
`;

export const ContentElement = styled.div`
  position: fixed !important;
  inset: 0 !important;

  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  
  width: 100vw !important;
  height: 100vh !important;

  background: var(--black-200) !important;
  border-radius: 4px !important;
  border: none !important;
  padding: 0px !important;
`;

export const Header = styled.header`
  padding-top: 1rem;

  width: 100%;

  border-bottom: 1px solid rgba(82, 82, 82, 0.64);

  .titleContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    padding: 0 1.5rem;
    padding-bottom: 0.7rem;

    img {
      cursor: pointer;
    }

    .titleContainer_text{
      display: flex;
      align-items: center;
      gap: 1em;
      justify-content: flex-start;
    }
  }

  > div {
    padding: 0 1.5rem;
  }
`;

export const Footer = styled.footer`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  border-top: 1px solid rgba(82, 82, 82, 0.64);

  width: 100%;
  height: 80px;

  padding: 1rem 1.5rem 1rem;

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;

    button:last-of-type {
      margin-left: 1rem;
    }

    img {
      transform: rotate(180deg);
      color: black;
    }
  }

  button {
    font-weight: 600;
    font-family: Inter;
    font-size: 0.9rem;

    padding: 0.65rem 1.5rem;

    border-radius: 4px;

    transition: background 0.3s;

    &.saveButton {
      &:disabled {
        background: var(--grey-200) !important;
        color: var(--grey-300) !important;
        cursor: default;
      }
    }

    &:disabled {
      background: var(--grey-200) !important;
      color: var(--grey-300) !important;
      cursor: default;
    }
    &.oneTabSaveButton {
      margin-left: auto !important;
      background: var(--primary);
      &:disabled {
        background: var(--grey-200) !important;
        color: var(--grey-300) !important;
        cursor: default;
      }
    }
  }
`;

export const Button = styled.button`
  background-color: var(--white);
  color: var(--black-100);
  border: 1px solid var(--white);
  width: fit-content;
  padding: .65em;
  transition: all 0.3s ease-in-out;
  font-size: 1rem;
  font-weight: 600;

  :hover{
    cursor: pointer;
    background-color: var(--black-300);
    color: var(--white);
  }
`